module.exports = __webpack_public_path__ + "static/media/tooltip-arrow-left.b3b2a8bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tooltip-arrow-left.svg
// module id = 1087
// module chunks = 0